export default "__VITE_ASSET__BBfJHZhp__"